/* English translations for the client intake form (/formulario-web).
 * Keys are the canonical SPANISH strings stored in the database; values are English
 * display text. Lookup falls back to the key itself when missing, so Spanish is
 * always the safe default and conditionals/admin logic keep working on canonical values. */
export const EN = {
  /* generic */
  "Sí": "Yes",
  "No": "No",
  "Otro": "Other",
  "No aplica": "Not applicable",
  "No estoy seguro/a": "I'm not sure",
  "Tal vez": "Maybe",
  "Selecciona una opción": "Select an option",
  "Especifica “Otro”": "Please specify “Other”",

  /* header / nav / messages */
  "Cuéntanos sobre tu negocio": "Tell us about your business",
  "% completado": "% completed",
  "Paso": "Step",
  "de": "of",
  "Anterior": "Previous",
  "Guardar y continuar": "Save & continue",
  "Siguiente": "Next",
  "Enviar mi información": "Submit my information",
  "Enviando...": "Sending...",
  "Subiendo archivo…": "Uploading file…",
  "Por favor completa los campos obligatorios (*) antes de continuar.": "Please complete the required fields (*) before continuing.",
  "Debes confirmar la autorización para enviar el formulario.": "Please confirm the authorization to submit the form.",
  "Faltan datos obligatorios: nombre del negocio, dueño/a, correo y teléfono.": "Missing required information: business name, owner, email and phone.",
  "Ocurrió un error al enviar. Intenta de nuevo.": "Something went wrong while submitting. Please try again.",
  "Guardado. Puedes continuar más tarde en este mismo dispositivo.": "Saved. You can continue later on this same device.",
  "Ingresa un correo válido.": "Please enter a valid email address.",

  /* step labels */
  "Tu negocio": "Your business",
  "Tu negocio hoy": "Your business today",
  "Metas de crecimiento": "Growth goals",
  "Retos actuales": "Current challenges",
  "Tus clientes": "Your customers",
  "Objetivo de la web": "Website goals",
  "Marca y diseño": "Brand & design",
  "Páginas": "Pages",
  "Historia": "Your story",
  "Sobre ti y tu equipo": "About you & your team",
  "Servicios o productos": "Services or products",
  "Credibilidad": "Credibility",
  "Fotos y contenido": "Photos & content",
  "Servicios de limpieza": "Cleaning services",
  "Contacto": "Contact",
  "Redes sociales": "Social media",
  "Funciones": "Features",
  "Información importante": "Important information",
  "Tu visión": "Your vision",
  "Revisión": "Review",

  /* intro */
  "Cuéntanos sobre tu negocio y hacia dónde quieres llevarlo": "Tell us about your business and where you want to take it",
  "Este formulario nos ayudará a conocer tu negocio, tus clientes, tus servicios, tu marca y tus metas de crecimiento. La información que compartas nos permitirá crear una presencia digital profesional que represente correctamente tu empresa y apoye tus próximos pasos.":
    "This form will help us get to know your business, your customers, your services, your brand, and your growth goals. The information you share will allow us to create a professional online presence that correctly represents your company and supports your next steps.",
  "No tienes que tener todas las respuestas. Si no estás seguro/a de algo, puedes escribir “No estoy seguro/a” y podremos ayudarte.":
    "You don't need to have all the answers. If you're not sure about something, you can write “I'm not sure” and we'll help you.",

  /* step: negocio */
  "Nombre del negocio": "Business name",
  "Nombre del dueño/a o fundador/a": "Name of the owner or founder",
  "¿A qué se dedica tu negocio?": "What does your business do?",
  "Ejemplo: construcción, limpieza, restaurante, belleza, educación, transporte, servicios profesionales, etc.":
    "Example: construction, cleaning, restaurant, beauty, education, transportation, professional services, etc.",
  "Cuéntanos brevemente sobre tu negocio. ¿Qué haces y cómo ayudas a tus clientes?":
    "Tell us briefly about your business. What do you do and how do you help your customers?",
  "¿Tu negocio tiene una ubicación física?": "Does your business have a physical location?",
  "Trabajo desde casa": "I work from home",
  "Voy a la ubicación del cliente": "I go to the client's location",
  "Mi negocio es completamente virtual": "My business is completely virtual",
  "Dirección del negocio (opcional)": "Business address (optional)",
  "¿Qué ciudades, condados o áreas atiendes?": "Which cities, counties, or areas do you serve?",
  "Ejemplo: Oxford, Chester County, Lancaster County, Pennsylvania, Delaware, Maryland, etc.":
    "Example: Oxford, Chester County, Lancaster County, Pennsylvania, Delaware, Maryland, etc.",
  "¿Ofreces servicios virtuales u online?": "Do you offer virtual or online services?",
  "Algunos servicios": "Some services",

  /* step: etapa */
  "Cada negocio está en una etapa diferente. Queremos entender dónde estás actualmente para poder crear una página web que represente tu negocio hoy y apoye hacia dónde quieres crecer.":
    "Every business is at a different stage. We want to understand where you are today so we can create a website that represents your business now and supports where you want to grow.",
  "¿En qué etapa se encuentra tu negocio actualmente?": "What stage is your business currently in?",
  "Tengo una idea de negocio, pero todavía no he comenzado": "I have a business idea, but I haven't started yet",
  "Estoy comenzando y todavía estoy desarrollando mi negocio": "I'm starting out and still developing my business",
  "Ya estoy operando y tengo algunos clientes": "I'm already operating and have some customers",
  "Tengo un negocio establecido y quiero conseguir más clientes": "I have an established business and want to get more customers",
  "Tengo un negocio establecido y quiero profesionalizar mi marca": "I have an established business and want to make my brand more professional",
  "Tengo un negocio establecido y quiero expandirme": "I have an established business and want to expand",
  "Quiero comenzar a trabajar con empresas u organizaciones": "I want to start working with companies or organizations",
  "¿Cuánto tiempo lleva operando tu negocio?": "How long has your business been operating?",
  "Todavía no he comenzado": "I haven't started yet",
  "Menos de 1 año": "Less than 1 year",
  "1–2 años": "1–2 years",
  "3–5 años": "3–5 years",
  "6–10 años": "6–10 years",
  "Más de 10 años": "More than 10 years",
  "¿Cómo consigues la mayoría de tus clientes actualmente?": "How do you currently get most of your customers?",
  "Recomendaciones / Boca a boca": "Referrals / Word of mouth",
  "Clientes recurrentes": "Repeat customers",
  "Página web": "Website",
  "Networking / Eventos": "Networking / Events",
  "Volantes / Tarjetas de presentación": "Flyers / Business cards",
  "Contratos comerciales": "Commercial contracts",
  "Alianzas con otras empresas u organizaciones": "Partnerships with other businesses or organizations",
  "Plataformas de servicios": "Service platforms",
  "Todavía no tengo clientes": "I don't have customers yet",
  "Aproximadamente, ¿cuántos clientes atiendes actualmente?": "Approximately how many customers do you currently serve?",
  "Más de 50": "More than 50",
  "Depende del mes": "Depends on the month",
  "Prefiero no responder": "Prefer not to answer",
  "¿Cómo está organizado tu negocio actualmente?": "How is your business currently organized?",
  "Trabajo solo/a": "I work alone",
  "Tengo empleados": "I have employees",
  "Trabajo con contratistas": "I work with contractors",
  "Tengo empleados y contratistas": "I have employees and contractors",
  "Trabajo con familiares o socios": "I work with family members or partners",
  "Estoy buscando contratar próximamente": "I'm looking to hire soon",
  "¿Cuántas personas aproximadamente forman parte de tu equipo?": "Approximately how many people are on your team?",
  "Esta información es solo para planificación interna y no aparecerá automáticamente en tu página web pública.":
    "This information is for internal planning only and will not automatically appear on your public website.",

  /* step: metas */
  "Ahora queremos conocer tus próximos pasos. Esto nos ayudará a crear una página web enfocada no solamente en lo que haces actualmente, sino también en las oportunidades que quieres atraer.":
    "Now we want to know your next steps. This will help us create a website focused not only on what you do today, but also on the opportunities you want to attract.",
  "¿Qué quieres lograr con tu negocio durante los próximos 6–12 meses?": "What do you want to achieve with your business in the next 6–12 months?",
  "Ejemplo: conseguir más clientes, aumentar mis ingresos, contratar empleados, conseguir contratos comerciales, expandirme a nuevas áreas, ofrecer nuevos servicios, mejorar mi marca, etc.":
    "Example: get more customers, increase my income, hire employees, win commercial contracts, expand to new areas, offer new services, improve my brand, etc.",
  "¿Qué tipo de clientes quieres conseguir MÁS?": "What type of customers do you want to get MORE of?",
  "Piensa en los clientes que realmente quieres atraer durante esta próxima etapa de tu negocio.":
    "Think about the customers you really want to attract during this next stage of your business.",
  "¿Hay algún tipo de cliente, proyecto o trabajo que NO quieres atraer?": "Is there any type of customer, project, or job you do NOT want to attract?",
  "¿Qué servicios o productos quieres promocionar o expandir más?": "Which services or products do you want to promote or expand the most?",
  "¿Hay algún servicio o producto nuevo que quieres comenzar a ofrecer?": "Is there a new service or product you want to start offering?",
  "¿Quieres trabajar con empresas, organizaciones o clientes comerciales?": "Do you want to work with companies, organizations, or commercial clients?",
  "Ya trabajo con clientes comerciales": "I already work with commercial clients",
  "Tal vez en el futuro": "Maybe in the future",
  "No aplica a mi negocio": "Doesn't apply to my business",
  "¿Qué tipo de empresas u organizaciones quieres atraer?": "What types of companies or organizations do you want to attract?",
  "Ejemplo: oficinas, restaurantes, escuelas, administradores de propiedades, compañías de construcción, tiendas, organizaciones sin fines de lucro, etc.":
    "Example: offices, restaurants, schools, property managers, construction companies, stores, nonprofit organizations, etc.",
  "¿Actualmente tienes contratos comerciales o clientes empresariales que puedas mencionar públicamente?":
    "Do you currently have commercial contracts or business clients you can mention publicly?",
  "Escribe solamente los nombres de las empresas u organizaciones que tienes autorización para mencionar públicamente.":
    "Write only the names of companies or organizations you are authorized to mention publicly.",
  "¿Quieres expandir tu negocio a nuevas ciudades, condados o áreas?": "Do you want to expand your business to new cities, counties, or areas?",
  "¿A qué nuevas áreas te gustaría expandirte?": "Which new areas would you like to expand to?",

  /* step: retos */
  "¿Qué crees que actualmente está limitando el crecimiento de tu negocio?": "What do you think is currently limiting the growth of your business?",
  "No tengo página web": "I don't have a website",
  "Mi página web necesita mejorar": "My website needs improvement",
  "No tengo suficiente presencia en redes sociales": "I don't have enough social media presence",
  "Dependo demasiado de recomendaciones": "I rely too much on referrals",
  "Necesito conseguir más clientes": "I need to get more customers",
  "Quiero conseguir mejores clientes": "I want to get better customers",
  "Quiero conseguir clientes comerciales": "I want to get commercial clients",
  "Mi negocio no se ve tan profesional como quisiera": "My business doesn't look as professional as I'd like",
  "Necesito mejorar mi marca": "I need to improve my brand",
  "Necesito mejorar mi marketing": "I need to improve my marketing",
  "No sé cómo promocionar mi negocio": "I don't know how to promote my business",
  "Necesito más reseñas o testimonios": "I need more reviews or testimonials",
  "Necesito mejores fotos de mi trabajo": "I need better photos of my work",
  "Necesito contratar personal": "I need to hire staff",
  "Necesito mejores sistemas para manejar clientes": "I need better systems to manage customers",
  "Necesito organizar mejor mis servicios": "I need to better organize my services",
  "¿Cuál es el MAYOR reto que tienes actualmente para hacer crecer tu negocio?": "What is the BIGGEST challenge you currently have in growing your business?",
  "Pregunta clave": "Key question",
  "Si pudiéramos diseñar tu página web para ayudarte a alcanzar UNA meta principal, ¿cuál sería?":
    "If we could design your website to help you reach ONE main goal, what would it be?",
  "Tu respuesta es muy importante: nos ayuda a definir la estrategia y la llamada a la acción principal de tu página web.":
    "Your answer is very important: it helps us define the strategy and the main call-to-action of your website.",

  /* step: clientes */
  "¿Quiénes son tus clientes actualmente?": "Who are your current customers?",
  "Individuos": "Individuals",
  "Familias": "Families",
  "Niños": "Children",
  "Adultos": "Adults",
  "Dueños de casas": "Homeowners",
  "Dueños de negocios": "Business owners",
  "Empresas": "Companies",
  "Organizaciones sin fines de lucro": "Nonprofit organizations",
  "Escuelas": "Schools",
  "Profesionales": "Professionals",
  "¿Quiénes son los clientes que MÁS quieres atraer en el futuro?": "Who are the customers you MOST want to attract in the future?",
  "Describe a tu cliente ideal: ¿qué tipo de persona, empresa u organización quieres atraer?":
    "Describe your ideal customer: what type of person, company, or organization do you want to attract?",
  "¿Qué problema o necesidad principal tiene ese cliente que tu negocio puede ayudar a resolver?":
    "What main problem or need does that customer have that your business can help solve?",
  "¿Qué es lo más importante para ese cliente cuando está eligiendo una empresa como la tuya?":
    "What is most important to that customer when choosing a company like yours?",

  /* step: objetivo */
  "¿Qué papel quieres que tenga tu página web en el crecimiento de tu negocio?": "What role do you want your website to play in the growth of your business?",
  "Ayudarme a conseguir clientes": "Help me get customers",
  "Ayudarme a conseguir clientes comerciales": "Help me get commercial clients",
  "Mostrar mis servicios profesionalmente": "Showcase my services professionally",
  "Generar solicitudes de cotización": "Generate quote requests",
  "Generar llamadas": "Generate phone calls",
  "Generar citas": "Generate appointments",
  "Mostrar mi trabajo": "Showcase my work",
  "Mostrar reseñas": "Showcase reviews",
  "Dar credibilidad a mi empresa": "Give my business credibility",
  "Ayudarme a expandirme a nuevas áreas": "Help me expand to new areas",
  "Ayudarme a contratar empleados": "Help me hire employees",
  "Vender productos": "Sell products",
  "Recibir pagos": "Accept payments",
  "Registrar participantes/clientes": "Register participants/customers",
  "¿Cuál de estos objetivos es el MÁS importante?": "Which of these goals is the MOST important?",
  "¿Cuál es la acción MÁS importante que quieres que realice una persona?": "What is the MOST important action you want a visitor to take?",
  "Llamarme": "Call me",
  "Enviarme un mensaje": "Send me a message",
  "Solicitar una cotización": "Request a quote",
  "Reservar una cita": "Book an appointment",
  "Registrarse": "Register",
  "Comprar": "Buy",
  "Visitar mi negocio": "Visit my business",
  "¿Actualmente tienes una página web?": "Do you currently have a website?",
  "Enlace de tu página web actual": "Link to your current website",
  "¿Qué te gustaría cambiar o mejorar de tu página actual?": "What would you like to change or improve about your current website?",

  /* step: marca */
  "¿Ya tienes un logo?": "Do you already have a logo?",
  "Necesito ayuda con mi logo": "I need help with my logo",
  "Sube tu logo": "Upload your logo",
  "JPG, JPEG, PNG, WEBP o PDF.": "JPG, JPEG, PNG, WEBP or PDF.",
  "Subir logo": "Upload logo",
  "¿Cuáles son los colores de tu negocio?": "What are your business colors?",
  "Si todavía no tienes colores definidos, escribe: Necesito ayuda para elegirlos.":
    "If you don't have defined colors yet, write: I need help choosing them.",
  "¿Cómo quieres que se vea y se sienta tu página web? (hasta 5)": "How do you want your website to look and feel? (up to 5)",
  "Profesional": "Professional",
  "Moderna": "Modern",
  "Elegante": "Elegant",
  "Sencilla / Minimalista": "Simple / Minimalist",
  "Amigable": "Friendly",
  "Familiar": "Family-oriented",
  "Creativa": "Creative",
  "Lujosa": "Luxurious",
  "Corporativa": "Corporate",
  "Divertida": "Fun",
  "Educativa": "Educational",
  "Acogedora": "Warm / Welcoming",
  "Enfocada en la comunidad": "Community-focused",
  "Fuerte / Atrevida": "Bold",
  "¿Hay colores o estilos que NO quieres utilizar?": "Are there any colors or styles you do NOT want to use?",
  "¿Hay alguna página web que te guste como inspiración? (pega uno o varios enlaces)":
    "Is there a website you like as inspiration? (paste one or more links)",
  "¿Qué te gusta de esas páginas?": "What do you like about those websites?",

  /* step: paginas */
  "Selecciona las páginas que te gustaría tener.": "Select the pages you would like to have.",
  "Inicio": "Home",
  "Sobre Nosotros / Acerca de": "About Us",
  "Servicios": "Services",
  "Productos": "Products",
  "Contacto": "Contact",
  "Galería": "Gallery",
  "Portafolio": "Portfolio",
  "Testimonios": "Testimonials",
  "Preguntas Frecuentes": "Frequently Asked Questions",
  "Reservar una Cita": "Book an Appointment",
  "Solicitar Cotización": "Request a Quote",
  "Registro / Inscripción": "Registration / Sign-up",
  "Eventos": "Events",
  "¿En qué idioma necesitas tu página web?": "What language do you need your website in?",
  "Español": "Spanish",
  "Inglés": "English",
  "Inglés y Español": "English and Spanish",

  /* step: historia */
  "Tu historia puede ayudarnos a crear una página que represente realmente quién eres y por qué haces este trabajo.":
    "Your story can help us create a website that truly represents who you are and why you do this work.",
  "Cuéntanos la historia de tu negocio.": "Tell us the story of your business.",
  "Puedes contarnos por qué comenzaste, qué te inspiró, cómo surgió la idea, cómo has crecido y qué significa este negocio para ti.":
    "You can tell us why you started, what inspired you, how the idea came about, how you've grown, and what this business means to you.",
  "¿Cuál es la misión de tu negocio?": "What is your business's mission?",
  "¿Qué quieres lograr para tus clientes o tu comunidad?": "What do you want to achieve for your customers or your community?",
  "¿Qué hace que tu negocio sea diferente?": "What makes your business different?",
  "¿Por qué un cliente debería elegirte a ti en lugar de otra empresa similar?":
    "Why should a customer choose you over a similar company?",
  "Las 3 cosas más importantes que quieres que las personas sepan": "The 3 most important things you want people to know",

  /* step: equipo */
  "¿Quieres incluir una sección \"Conoce al Dueño/a\" o \"Conoce al Fundador/a\"?": "Do you want to include a “Meet the Owner” or “Meet the Founder” section?",
  "Cuéntanos un poco sobre ti.": "Tell us a little about yourself.",
  "Experiencia, educación, historia profesional, participación en la comunidad y por qué haces este trabajo.":
    "Experience, education, professional background, community involvement, and why you do this work.",
  "¿Tienes licencias, certificaciones, títulos u otras credenciales que quieras mostrar?":
    "Do you have licenses, certifications, degrees, or other credentials you want to show?",
  "Importante: solo incluye credenciales reales. No inventaremos ninguna.":
    "Important: only include real credentials. We will not invent any.",
  "¿Quieres incluir otros miembros de tu equipo?": "Do you want to include other team members?",
  "Miembro": "Member",
  "Nombre": "Name",
  "Cargo": "Role",
  "Breve biografía": "Short bio",
  "Credenciales (solo reales)": "Credentials (real ones only)",
  "Subir foto": "Upload photo",
  "Agregar otro miembro": "Add another member",

  /* step: servicios */
  "Agrega tus servicios o productos principales — tanto los que ofreces hoy como los que quieres comenzar a ofrecer. Esto nos ayudará a crear la sección de Servicios de tu página web.":
    "Add your main services or products — both the ones you offer today and the ones you want to start offering. This will help us create the Services section of your website.",
  "Servicio / Producto": "Service / Product",
  "Nombre del servicio o producto *": "Name of the service or product *",
  "Describe este servicio o producto": "Describe this service or product",
  "¿Para quién es?": "Who is it for?",
  "¿Qué problema resuelve?": "What problem does it solve?",
  "¿Qué incluye?": "What does it include?",
  "Área donde se ofrece": "Area where it's offered",
  "¿Es un servicio actual o nuevo?": "Is it a current or new service?",
  "Lo ofrezco actualmente": "I currently offer it",
  "Es un servicio nuevo que quiero comenzar a ofrecer": "It's a new service I want to start offering",
  "Estoy considerando ofrecerlo": "I'm considering offering it",
  "¿Quieres destacar este servicio en la página de inicio?": "Do you want to feature this service on the homepage?",
  "¿Quieres mostrar el precio?": "Do you want to show the price?",
  "Mostrar \"Desde $___\"": "Show \"Starting at $___\"",
  "Solicitar cotización": "Request a quote",
  "Contactar para precio": "Contact for price",
  "Precio": "Price",
  "¿Qué quieres que haga el cliente después?": "What do you want the customer to do next?",
  "Contactarnos": "Contact us",
  "Llamar": "Call",
  "Reservar": "Book",
  "Aprender más": "Learn more",
  "Agregar servicio o producto": "Add service or product",

  /* step: credibilidad */
  "Queremos identificar información REAL que podamos utilizar para fortalecer la credibilidad de tu página web. No necesitas tener todas estas cosas para tener una buena página web.":
    "We want to identify REAL information we can use to strengthen the credibility of your website. You don't need to have all of these things to have a good website.",
  "Selecciona solamente información que sea verdadera.": "Select only information that is true.",
  "¿Cuáles de estas cosas tiene actualmente tu negocio?": "Which of these does your business currently have?",
  "Negocio registrado": "Registered business",
  "Seguro comercial": "Business insurance",
  "Licencia profesional": "Professional license",
  "Certificaciones": "Certifications",
  "Experiencia profesional": "Professional experience",
  "Empleados o equipo": "Employees or team",
  "Clientes comerciales": "Commercial clients",
  "Reseñas de clientes": "Customer reviews",
  "Fotos de trabajos realizados": "Photos of completed work",
  "Fotos de antes y después": "Before and after photos",
  "Asociaciones profesionales": "Professional associations",
  "Premios o reconocimientos": "Awards or recognition",
  "Ninguno todavía": "None yet",
  "¿Tu negocio está asegurado?": "Is your business insured?",
  "Prefiero no incluir esta información": "I prefer not to include this information",
  "¿Quieres que mencionemos en tu página web que tu negocio está asegurado?": "Do you want us to mention on your website that your business is insured?",
  "¿Tu negocio tiene alguna licencia profesional o comercial que quieras mencionar?":
    "Does your business have a professional or commercial license you want to mention?",
  "Escribe el nombre de la licencia exactamente como debe aparecer.": "Write the name of the license exactly as it should appear.",
  "Documento de la licencia (opcional)": "License document (optional)",
  "Subir documento": "Upload document",
  "Subir documento (opcional)": "Upload document (optional)",
  "¿Tienes certificaciones profesionales que quieras mostrar?": "Do you have professional certifications you want to show?",
  "Certificación": "Certification",
  "Nombre de la certificación": "Name of the certification",
  "Organización que la otorgó": "Issuing organization",
  "Año (opcional)": "Year (optional)",
  "Agregar otra certificación": "Add another certification",
  "¿Cuántos años de experiencia profesional tienes en este tipo de trabajo?": "How many years of professional experience do you have in this type of work?",
  "Esto puede ser diferente al tiempo que lleva registrado tu negocio.":
    "This can be different from how long your business has been registered.",

  /* step: fotos */
  "¿Qué fotografías tienes disponibles?": "Which photos do you have available?",
  "Foto del dueño/a": "Photo of the owner",
  "Fotos del equipo": "Team photos",
  "Fotos del negocio": "Business photos",
  "Fotos de mis servicios": "Photos of my services",
  "Fotos de productos": "Product photos",
  "Fotos de eventos": "Event photos",
  "Videos": "Videos",
  "No tengo fotos todavía": "I don't have photos yet",
  "Sube las fotografías que quieres utilizar": "Upload the photos you want to use",
  "JPG, JPEG, PNG, WEBP. Puedes subir varias.": "JPG, JPEG, PNG, WEBP. You can upload several.",
  "Subir fotos": "Upload photos",
  "¿Tienes fotografías reales de trabajos que hayas realizado?": "Do you have real photos of work you have done?",
  "¿Tienes fotografías de antes y después?": "Do you have before and after photos?",
  "Especialmente útil para negocios de limpieza, jardinería, construcción, belleza, servicios del hogar, etc.":
    "Especially useful for cleaning, landscaping, construction, beauty, home services, etc.",
  "Antes / Después": "Before / After",
  "ANTES": "BEFORE",
  "DESPUÉS": "AFTER",
  "Describe brevemente el trabajo realizado (opcional)": "Briefly describe the work done (optional)",
  "Agregar otro antes/después": "Add another before/after set",
  "¿Tienes reseñas reales de clientes?": "Do you have real customer reviews?",
  "Solo incluye nombres e información que tengas autorización para publicar.":
    "Only include names and information you are authorized to publish.",
  "Reseña": "Review",
  "Nombre del cliente": "Customer name",
  "Testimonio": "Testimonial",
  "Empresa (si aplica)": "Company (if applicable)",
  "Agregar otra reseña": "Add another review",

  /* step: limpieza */
  "Estas preguntas adicionales son opcionales y nos ayudan a adaptar la estrategia de tu página web a los servicios de limpieza.":
    "These additional questions are optional and help us tailor your website strategy to cleaning services.",
  "¿Qué tipo de servicios de limpieza ofreces?": "What types of cleaning services do you offer?",
  "Limpieza residencial": "Residential cleaning",
  "Limpieza comercial": "Commercial cleaning",
  "Limpieza de oficinas": "Office cleaning",
  "Limpieza profunda": "Deep cleaning",
  "Limpieza recurrente": "Recurring cleaning",
  "Mudanzas / Move-in / Move-out": "Move-in / Move-out cleaning",
  "Airbnb / alquileres a corto plazo": "Airbnb / short-term rentals",
  "Propiedades de alquiler": "Rental properties",
  "Post-construcción": "Post-construction",
  "Limpieza para Realtors": "Cleaning for Realtors",
  "¿Ofreces servicios recurrentes?": "Do you offer recurring services?",
  "¿Con qué frecuencia pueden contratarte?": "How often can customers hire you?",
  "Una sola vez": "One time",
  "Semanal": "Weekly",
  "Cada dos semanas": "Every two weeks",
  "Mensual": "Monthly",
  "Según necesidad": "As needed",
  "¿Ofreces estimados o cotizaciones?": "Do you offer estimates or quotes?",
  "Sí, gratis": "Yes, free",
  "Sí, con costo": "Yes, for a fee",
  "Depende del trabajo": "Depends on the job",
  "¿Cómo prefieres preparar una cotización?": "How do you prefer to prepare a quote?",
  "Por teléfono": "By phone",
  "Por formulario": "By form",
  "Con fotografías": "With photos",
  "Visita en persona": "In-person visit",
  "Video": "Video",
  "¿Qué tipo de trabajo quieres conseguir MÁS?": "What type of work do you want to get MORE of?",
  "¿Quieres conseguir contratos de limpieza comercial?": "Do you want to get commercial cleaning contracts?",
  "Ya tengo contratos comerciales": "I already have commercial contracts",

  /* step: contacto */
  "Número de teléfono del negocio": "Business phone number",
  "Correo electrónico del negocio": "Business email address",
  "Dirección del negocio": "Business address",
  "Horario": "Business hours",
  "¿Cómo prefieres que los clientes se comuniquen contigo?": "How do you prefer customers contact you?",
  "Llamada": "Phone call",
  "Mensaje de texto": "Text message",
  "Correo electrónico": "Email",
  "Formulario de contacto": "Contact form",
  "Reservar una cita": "Book an appointment",

  /* step: redes */
  "Otro": "Other",

  /* step: funciones */
  "¿Qué funciones necesitas?": "Which features do you need?",
  "Solicitud de cotización": "Quote request",
  "Reservación de citas": "Appointment booking",
  "Pagos online": "Online payments",
  "Tienda online": "Online store",
  "Galería de fotos": "Photo gallery",
  "Preguntas frecuentes": "Frequently asked questions",
  "Redes sociales": "Social media",
  "Suscripción por correo electrónico": "Email subscription",
  "Calendario de eventos": "Event calendar",
  "¿Quieres que los clientes puedan reservar citas directamente?": "Do you want customers to be able to book appointments directly?",
  "Tal vez más adelante": "Maybe later",
  "¿Qué sistema utilizas actualmente?": "Which system do you currently use?",
  "No utilizo ninguno todavía": "I don't use any yet",
  "¿Quieres aceptar pagos directamente desde la página?": "Do you want to accept payments directly on the website?",
  "¿Qué sistema utilizas?": "Which system do you use?",
  "No tengo uno todavía": "I don't have one yet",

  /* step: importante */
  "¿Cuáles son las preguntas que tus clientes te hacen con más frecuencia?": "What questions do your customers ask you most often?",
  "Estas respuestas pueden ayudarnos a crear una sección de Preguntas Frecuentes.":
    "These answers can help us create a Frequently Asked Questions section.",
  "¿Hay algo importante que los clientes deben saber antes de contratarte o comprar?":
    "Is there anything important customers should know before hiring you or buying?",
  "Ejemplo: depósitos, políticas de cancelación, áreas de servicio, requisitos, citas, tiempos de entrega, etc.":
    "Example: deposits, cancellation policies, service areas, requirements, appointments, delivery times, etc.",
  "¿Hay algo que NO quieres que aparezca públicamente en tu página web?": "Is there anything you do NOT want to appear publicly on your website?",

  /* step: vision */
  "“Cuando alguien visite mi página web, quiero que inmediatamente entienda que…”":
    "“When someone visits my website, I want them to immediately understand that…”",
  "Después de visitar tu página web, quiero que esa persona...": "After visiting my website, I want that person to...",
  "Las 3 cosas MÁS importantes que quieres mostrar en la página de inicio": "The 3 MOST important things you want to show on the homepage",
  "¿Hay algo más que debamos saber antes de comenzar a crear tu página web?": "Is there anything else we should know before starting to create your website?",

  /* review screen */
  "Revisa tu información. Puedes editar cualquier sección antes de enviar.": "Review your information. You can edit any section before submitting.",
  "Editar": "Edit",
  "Información del negocio": "Business information",
  "Negocio": "Business",
  "Dueño/a": "Owner",
  "Industria": "Industry",
  "Descripción": "Description",
  "Área de servicio": "Service area",
  "Etapa": "Stage",
  "Tiempo operando": "Time operating",
  "Fuente de clientes": "Customer sources",
  "Organización": "Structure",
  "Metas 6–12 meses": "6–12 month goals",
  "Clientes que quiere más": "Customers they want more of",
  "Clientes comerciales": "Commercial clients",
  "Expandir áreas": "Expand areas",
  "Mayor reto": "Biggest challenge",
  "Una meta principal": "One main goal",
  "Clientes actuales": "Current customers",
  "Clientes que quiere atraer": "Customers they want to attract",
  "Objetivos": "Goals",
  "Objetivo principal": "Main goal",
  "Acción principal": "Main action",
  "Logo": "Logo",
  "Colores": "Colors",
  "Estilo": "Style",
  "Idioma": "Language",
  "Diferenciadores": "Differentiators",
  "Sección dueño/a": "Owner section",
  "Miembros del equipo": "Team members",
  "Elementos": "Items",
  "Asegurado": "Insured",
  "Licencia": "License",
  "Experiencia": "Experience",
  "Fotos subidas": "Photos uploaded",
  "Antes/Después": "Before/After",
  "conjunto(s)": "set(s)",
  "Reseñas": "Reviews",
  "Tipos": "Types",
  "Recurrentes": "Recurring",
  "Comercial": "Commercial",
  "Teléfono": "Phone",
  "Entender que": "Understand that",
  "Quiero que la persona": "I want the person to",
  "Confirmo que la información proporcionada es correcta y autorizo su uso para desarrollar el contenido de mi página web.":
    "I confirm that the information provided is accurate and I authorize its use to develop the content of my website.",

  /* success */
  "¡Gracias! Hemos recibido la información de tu negocio. 🎉": "Thank you! We've received your business information. 🎉",
  "Utilizaremos esta información para comenzar a organizar el contenido, diseño y estructura de tu página web. Si necesitamos alguna información adicional, nos comunicaremos contigo.":
    "We will use this information to start organizing the content, design, and structure of your website. If we need any additional information, we will contact you.",
  "Puedes cerrar esta página.": "You can close this page.",
};
